// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> About Your Monthly Direct Debit Statement </h1> ";
// Exports
export default code;